import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(private translateService: TranslateService, private auth: AuthService) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes(environment.http.translations) || request.url.includes(environment.http.statusPage)) {
            return next.handle(request);
        }

        const lang = this.translateService.getDefaultLang() || environment.app.defaultLanguage;

        request = request.clone({ headers: request.headers.set('Accept-Language', lang) });

        return this.auth.csrfToken$.pipe(
            first((val) => val !== undefined),
            switchMap((value) =>
                next.handle(request.clone({ headers: request.headers.set('Authorization', `CSRF ${value}`) })).pipe(
                    catchError((e) => {
                        if (e instanceof HttpErrorResponse && e.status === 401) {
                            // refresh CSRF token and retry active request if fetching of token succeed
                            return this.auth.fetchNewCsrfToken().pipe(switchMap(() => this.intercept(request, next)));
                        }
                        throw e;
                    })
                )
            )
        );
    }
}
